import React from 'react';
import styled from 'styled-components';
import Spinner from 'react-bootstrap/Spinner';

const ContactsSpinner = () => {
  return (
    <ContactsSpinnerContainer>
      <Spinner animation="border" role="status"/>
    </ContactsSpinnerContainer>
  );
};

export const ContactsSpinnerContainer = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  margin-bottom: 1rem;
`;

export default ContactsSpinner;
